import { paymentClient } from "@core/clients";
import { TinkoffGetQr, TOrder } from "@core/types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "../../../config/query-client";

type UseCreateTinkoffQRMutationParams = {
  options?: Omit<UseMutationOptions<TinkoffGetQr | null, unknown, TOrder["id"], unknown>, "mutationFn">;
};

export default function useCreateTinkoffQRMutation({ options = {} }: UseCreateTinkoffQRMutationParams = {}) {
  return useMutation(
    ["create-tinkoff-qr"],
    async (orderId) => {
      return await paymentClient.createPaymentTinkoffQr(orderId);
    },
    {
      ...options,
      onSuccess(_, variables) {
        queryClient.invalidateQueries({ queryKey: ["t-payment", variables] });
      },
    },
  );
}
